import React, { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router';
import * as urls from 'constants/urls';
import StickySideModal from 'components/StickySideModal';
import UncertaintyAnalysis from 'components/uncertainty/UncertaintyAnalysis';
import './UncertaintyModal.scss';

const UncertaintyModal = ({ matrix, runOnMount }) => {
  const history = useHistory();

  const closeUrl = useMemo(() => {
    if (matrix?.parentId) return urls.experiment(matrix);
    return urls.matrix(matrix);
  }, [matrix]);

  useEffect(() => {
    runOnMount();
  }, [runOnMount]);

  return (
    <StickySideModal onExit={() => history.push(closeUrl)}>
      <div className="UncertaintyModal">
        <UncertaintyAnalysis matrix={matrix} closeUrl={closeUrl} />
      </div>
    </StickySideModal>
  );
};

export default UncertaintyModal;
